import * as Yup from "yup";
import { ERROR_MESSAGES } from "../utils/constant";
const VideoEditingValidationFields = {
  eventType: Yup.string().when("seasonType", {
    is: (val) => val !== "Off-Season" && val !== "Other",
    then: Yup.string()
      .required(ERROR_MESSAGES.eventType)
      .min(1, ERROR_MESSAGES.eventType),
    otherwise: Yup.string(),
  }),
  schoolId: Yup.string().required(ERROR_MESSAGES.schoolId),
  eventName: Yup.string().when("seasonType", {
    is: (val) => val !== "In-Season",
    then: Yup.string()
      .required(ERROR_MESSAGES.eventName)
      .min(1, ERROR_MESSAGES.eventName),
    otherwise: Yup.string(),
  }),
  practiceName: Yup.string().when("seasonType", {
    is: (val) => val !== "In-Season" && val !== "Other",
    then: Yup.string()
      .required(ERROR_MESSAGES.practiceName)
      .min(1, ERROR_MESSAGES.practiceNameMin),
    otherwise: Yup.string(),
  }),
  mediaFiles: Yup.array()
    .min(1, ERROR_MESSAGES.mediaFilesMin)
    .of(
      Yup.object().shape({
        fileName: Yup.string().required(ERROR_MESSAGES.fileName),
        filePath: Yup.string()
          .url(ERROR_MESSAGES.fileNameURL)
          .required(ERROR_MESSAGES.filePath),
      })
    ),
  seasonType: Yup.string().required(ERROR_MESSAGES.seasonType),
  scheduleId: Yup.string().required(ERROR_MESSAGES.scheduleId),
  isPractice: Yup.boolean().when("seasonType", {
    is: "Off-Season",
    then: Yup.boolean().required(ERROR_MESSAGES.isPractice),
    otherwise: Yup.boolean(),
  }),
  seasonId: Yup.string().required(ERROR_MESSAGES.seasonId),
  isEdited: Yup.boolean(),
};

export default VideoEditingValidationFields;
